module.exports = __webpack_public_path__ + "img/stategreen_bg.6eb73ec1.png";